import config from '../../config'
import store from '../store'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async initEcmm () {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.BASE_URL}/ecommerce-may`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': store.state.long_token
            }
          })
          const data = await res.json()
    
          if (res.status == 200) {
            resolve({
              exito: true,
              ...data
            })
          } else {
            throw new Error(data.message)
          }

        } catch (error) {
          resolve({
            exito: false,
            message: error.message
          })
        }
      })
    },
    async init () {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.BASE_URL}/ecommerce-may/init`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': store.state.long_token
            }
          })
          const data = await res.json()
    
          if (res.status == 200) {
            resolve({
              exito: true,
              ...data
            })
          } else {
            throw new Error(data.message)
          }

        } catch (error) {
          resolve({
            exito: false,
            message: error.message
          })
        }
      })
    },
    async getArticle ({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.BASE_URL}/ecommerce-may/article?code=${id}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': store.state.long_token
            }
          })
          const data = await res.json()
    
          if (res.status == 200) {
            resolve({
              exito: true,
              ...data
            })
          } else {
            throw new Error(data.message)
          }

        } catch (error) {
          resolve({
            exito: false,
            message: error.message
          })
        }
      })
    }
  }
}